export default {"src":"/_next/static/media/info.c1bd4d22.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};